import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { ReportTags } from "./ReportTags";
import type { ReportListResponseDto } from "@/api/dtos";
import type { ReportFile } from "./_models/Report";
import { toReportFileFromDto } from "./_transformers/toReportFileFromDto";

/** The adjustment report files on the eStore SFTP, newest first. */
export const getAdjustmentReportListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAdjustmentReportList: builder.query<ReportFile[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<ReportListResponseDto>(
            `${backendBase()}/adjustment-reports`,
            { headers: { Accept: "application/json" } },
          );
          const files = res.data.files
            .map((x) => toReportFileFromDto(x))
            .sort((a, b) => b.modified.localeCompare(a.modified));
          return { data: files };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: [{ type: ReportTags.AdjustmentReport, id: "LIST" }],
    }),
  }),
});

export const getAdjustmentReportList = getAdjustmentReportListApi.endpoints.getAdjustmentReportList;
